export default __webpack_public_path__ + "static/media/selectedSyncLogo.250e80b6.svg";